import { styled } from "@mui/material/styles";
import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { Box, FlexColumn, FlexSideDrawer, OverflowText } from "designSystem/index";
import { black, grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React from "react";
import MaterialCompositionDrawer from "src/Specification/MaterialCompositionDrawer";
import { TYPE_HIGG_MATERIAL, useHiggMaterialStore } from "./HiggMaterialStore";
import HiggMaterialCompositionSingleItem from "./HiggMaterialCompositionSingleItem";

const PREFIX = "HiggMaterialComposition";

const classes = {
	deleteButton: `${PREFIX}deleteButton`,
	drawerContainer: `${PREFIX}drawerContainer`,
	subtitle: `${PREFIX}subtitle`,
};

const StyledFlexSideDrawer = styled(FlexSideDrawer)((
	{
		theme,
	},
) => ({
	[`& .${classes.deleteButton}`]: {
		alignItems: "flex-end",
		paddingBottom: 0,
	},

	[`& .${classes.drawerContainer}`]: {
		backgroundColor: grey[200],
	},

	[`& .${classes.subtitle}`]: {
		color: black[500],
	},
}));

const HiggMaterialTableSection = observer(() => {
	const { routerStore } = useStore();
	const store = useHiggMaterialStore();
	const { defExampleMaterialView } = store;
	const { subtitle } = classes;

	const viewParams = {
		bPopup: true,
		defView: defExampleMaterialView,
	};

	return (
		<FlexColumn p={5}>
			<Box mb={1.5}>
				<OverflowText res="NewHiggMaterial_SubTitle1" />
			</Box>
			<Box growNoOverflow>
				<DojoView
					fullHeight
					nodeUrl={routerStore.locationUrl}
					viewId="HiggExampleMaterialLib"
					viewNodeType={TYPE_HIGG_MATERIAL}
					viewParams={viewParams}
				/>
			</Box>
		</FlexColumn>
	);
});

export const HiggMaterialComposition = observer(() => {
	const { clearComposition, compositions, count, currentHiggMaterial, higgCompositionGuidanceSatisfied, hint } = useHiggMaterialStore();
	return (
		<StyledFlexSideDrawer
			disabled
			drawerNode={(
				<MaterialCompositionDrawer 
					SingleItemComponent={HiggMaterialCompositionSingleItem}
					clearComposition={clearComposition}
					compositionGuidanceSatisfied={higgCompositionGuidanceSatisfied}
					compositions={compositions}
					count={count}
					hint={hint}
					hintTitle="HiggMaterial"
					parentTechnicalComposition={currentHiggMaterial}
				/>
			)}
			open
			rightDrawer
			widthOpen={280}
		>
			<HiggMaterialTableSection />
		</StyledFlexSideDrawer>
	);
});

export default HiggMaterialComposition;